// import i18n from "../translate/i18n";
// export function formatDateTimeUTC(value: string) {
//   const dateObj = new Date(value);
//   const date = dateObj.getUTCDate().toString().padStart(2, "0") + "/" + (dateObj.getUTCMonth()+1).toString().padStart(2, "0") + "/" + dateObj.getUTCFullYear();
//   let hours = dateObj.getUTCHours();
//   const minutes = dateObj.getUTCMinutes().toString().padStart(2,"0");
//   const ampm = i18n.language === "en" ? hours >= 12 ? "PM" : "AM" : hours >= 12 ? "م" : "ص";
//   hours = hours % 12 || 12;

//   const time = `${hours}:${minutes} ${ampm}`;

//   return { date, time };
// }
import i18n from "../translate/i18n";

export function formatDateTimeUTC(value: string) {
  const dateObj = new Date(value);
  const date =dateObj.getDate().toString().padStart(2, "0") + "/" +(dateObj.getMonth() + 1).toString().padStart(2, "0") +"/" + dateObj.getFullYear();
  let hours = dateObj.getHours();
  const minutes = dateObj.getMinutes().toString().padStart(2, "0");
  const ampm =i18n.language === "en"? hours >= 12? "PM": "AM": hours >= 12? "م": "ص";
  hours = hours % 12 || 12;

  const time = `${hours}:${minutes} ${ampm}`;

  // الفرق بين الوقت الحالي ووقت الإشعار
  const now = new Date();
  const diffMs = now.getTime() - dateObj.getTime();
  const diffSeconds = Math.floor(diffMs / 1000);
  const diffMinutes = Math.floor(diffSeconds / 60);
  const diffHours = Math.floor(diffMinutes / 60);
  const diffDays = Math.floor(diffHours / 24);

  let timeAgo = "";
  if (diffDays > 0) timeAgo =  i18n.language === "ar" ? `منذ ${diffDays} يوم`: `${diffDays} day${diffDays > 1 ? "s" : ""} ago`;
  else if (diffHours > 0) timeAgo = i18n.language === "ar" ? `منذ ${diffHours} ساعة` : `${diffHours} hour${diffHours > 1 ? "s" : ""} ago`;
  else if (diffMinutes > 0) timeAgo = i18n.language === "ar" ? `منذ ${diffMinutes} دقيقة` : `${diffMinutes} minute${diffMinutes > 1 ? "s" : ""} ago`;
  else timeAgo = "الآن";

  return { date, time, timeAgo };
}